import { Buffer } from "buffer";

// Legacy Solana web3/SPL packages still expect the browser Buffer global.
(globalThis as typeof globalThis & { Buffer: typeof Buffer }).Buffer = Buffer;
void import("./bootstrap.js");
